import type {
  ExtractionAiFieldCells,
  ExtractionAiFieldValues,
} from '~/features/dynamic-data-extraction/types/ExtractionAiFieldCell';

import { buildAiFieldCellKey } from './aiFieldCellKey';

export const migrateLegacyAiFieldValues = (
  aiFieldValues: ExtractionAiFieldValues | undefined,
): ExtractionAiFieldCells => {
  if (!aiFieldValues) {
    return {};
  }

  const aiFieldCells: ExtractionAiFieldCells = {};

  Object.entries(aiFieldValues).forEach(([documentHandlerId, cells]) => {
    Object.entries(cells).forEach(([fieldId, cell]) => {
      aiFieldCells[buildAiFieldCellKey(documentHandlerId, fieldId)] = cell;
    });
  });

  return aiFieldCells;
};
